export const OTHERS_THRESHOLD = 0.01;
export const OTHERS_LABEL = 'Others';
